import { FC } from "react";
import { DropdownMenuItem, toast } from "@altimateai/lego";
import { IconTrash } from "@tabler/icons-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Popconfirm } from "@altimateai/lego";
import { deletePrompt } from "@/helpers/apis";
import { PromptResponse } from "./types";
import { StudioTracking } from "@/lib/tracking/studio";

interface DeletePromptDialogProps {
  prompt: PromptResponse;
}

const DeletePromptDialog: FC<DeletePromptDialogProps> = ({ prompt }) => {
  const queryClient = useQueryClient();

  const { mutate: deletePromptMutation, isPending: isLoading } = useMutation({
    mutationFn: () => deletePrompt(prompt.id),
    onSuccess: () => {
      StudioTracking.promptDeleted(prompt.id);
      queryClient.invalidateQueries({ queryKey: ["prompts"] });
      toast({
        title: "Prompt deleted successfully",
      });
    },
    onError: error => {
      toast({
        title: "Failed to delete prompt",
        description: typeof error === "string" ? error : error?.message || String(error),
        variant: "destructive",
      });
    },
  });

  const handleDelete = () => {
    deletePromptMutation();
  };

  return (
    <Popconfirm
      title="Delete prompt"
      description="Are you sure you want to delete this prompt?"
      onConfirm={handleDelete}
    >
      <DropdownMenuItem
        disabled={isLoading}
        className="al-text-red-600 focus:al-text-red-600"
        onSelect={(e: Event) => e.preventDefault()}
      >
        <IconTrash className="al-h-4 al-w-4" />
        Delete
      </DropdownMenuItem>
    </Popconfirm>
  );
};

export default DeletePromptDialog;
